export enum ApiVersionEnum {
    Classic = 'Classic',
    International = 'International',
}
